<template>
  <div>
    <el-form label-width="140px" size="mini">
      <div :class="{ isHeading: item.uiType == 8 }" v-for="item in columnInfo" :key="item.id" :model="pageData">
        <div>
          <Spe v-if="item.id == 1012002" @change="getMFInfo" :preData="searchMf" :item="item">
          </Spe>
          <div v-else>
            <el-form-item :required="item.required" v-if="item.uiType == 1">
              <span slot="label">
                <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
                  <i class="el-icon-info"></i>
                  <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
                </el-tooltip>
                <span :title="item.name">{{ item.name }}</span>
              </span>

              <el-input maxlength="240" :style="input_width" v-model="pageData[item.index]" :disabled="!item.editable"
                @input="upInput(item.index)" @blur='emitInput(item.index)'></el-input>
            </el-form-item>
          </div>

        </div>

        <div>
          <el-form-item :required="item.required" v-if="item.uiType == 2">
            <span slot="label">
              <el-tooltip v-if="item.descriptions.length !== 0" effect="dark" placement="top-start">
                <i class="el-icon-info"></i>
                <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
              </el-tooltip>
              <span :title="item.name">{{ item.name }}</span>
            </span>
            <el-input maxlength="4000" show-word-limit type="textarea" :style="input_width" :disabled="!item.editable"
              v-model="pageData[item.index]" @input="upInput(item.index)" @blur='emitInput(item.index)'>
            </el-input>
          </el-form-item>
        </div>

        <div>
          <el-form-item v-if="[3, 4].includes(item.uiType)" :required="item.required">
            <span slot="label">
              <el-tooltip v-show="item.descriptions.length" effect="dark" placement="top-start">
                <i class="el-icon-info"></i>
                <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
              </el-tooltip>
              <span :title="item.name">{{ item.name }}</span>
            </span>
            <list :style="input_width" v-if="getLifeVal || pageIndex" :data="{ item, val: pageData[item.index] }"
              @change="upList" />
          </el-form-item>
        </div>
        <!-- <div>
          <el-form-item v-if="[4].includes(item.uiType)" :required="item.required">
            <span slot="label">
              <el-tooltip v-show="item.descriptions.length" effect="dark" placement="top-start">
                <i class="el-icon-info"></i>
                <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
              </el-tooltip>
              <span :title="item.name">{{ item.name }}</span>
            </span>

            <list v-if="getLifeVal || pageIndex" :data="{item,val:pageData[item.index]}" @change="upList" />
          </el-form-item>
        </div> -->

        <div>
          <el-form-item v-if="item.uiType == 6" :required="item.required">
            <span slot="label">
              <el-tooltip v-if="item.descriptions.length !== 0" effect="dark" placement="top-start">
                <i class="el-icon-info"></i>
                <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
              </el-tooltip>
              <span :title="item.name">{{ item.name }}</span>
            </span>
            <el-date-picker @change="upDateTime(item.index)" :style="input_width" v-model="pageData[item.index]"
              type="datetime" :placeholder="item.editable ? $t('message.placeholder.pickDate') : ''"
              :disabled="!item.editable">
            </el-date-picker>
          </el-form-item>
        </div>

        <div>
          <el-form-item :required="item.required" v-if="item.uiType == 7">
            <span slot="label">
              <el-tooltip v-if="item.descriptions.length !== 0" effect="dark" placement="top-start">
                <i class="el-icon-info"></i>
                <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
              </el-tooltip>
              <span :title="item.name">{{ item.name }}</span>
            </span>
            <!-- <el-input :style="input_width" :disabled="item.required"></el-input> -->
            <el-input :style="input_width" v-model="pageData[item.index]" @input="upInput(item.index)"
              @blur='emitInput(item.index)' :disabled="!item.editable"></el-input>
          </el-form-item>
        </div>

        <div class="heading" v-if="item.uiType == 8">
          <p>
            <i style="position: relative; top: 5px;margin-right: 5px;">
              <img src="@/assets/titleBlock/heading1.png" alt="">
            </i>
            {{ pageData[item.index] }}
            <i style="position: relative; top: 5px;margin-left: 5px;">
              <img src="@/assets/titleBlock/heading2.png" alt="">
            </i>
          </p>
        </div>

        <div class="moneyUi">
          <el-form-item :required="item.required" v-if="item.uiType == 10">
            <span slot="label">
              <el-tooltip v-if="item.descriptions.length !== 0" effect="dark" placement="top-start">
                <i class="el-icon-info"></i>
                <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
              </el-tooltip>
              <span :title="item.name">{{ item.name }}</span>
            </span>
            <el-input :style="input_width" v-model="pageData[item.index]" @input="upInput(item.index)"
              @blur='upCurrency(item.index)' :disabled="!item.editable">
              <el-select v-model="currencyIdList[item.index]" slot="append"
                :placeholder="$t('message.placeholder.select')" @change="upCurrencyId(item.index)"
                :disabled="!item.editable">
                <el-option :label="items.name" :value="items.id" v-for="items in item.listEntrie"
                  :key="items.id"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </div>


      </div>
    </el-form>
    <el-dialog v-if="searchAddList" class="searchAddList" :title="$t('message.title.add')" :visible.sync="searchAddList"
      :close-on-click-modal="!searchAddList" :close-on-press-escape="false" :modal="false">
      <searchListValues ref="searchList" @listDbClick="addToListDisplay" @listUpdate="updateListEntries"
        :listInfo="listInfo" />

    </el-dialog>
  </div>
</template>

<script>
import Spe from "./special.vue";
import axios from "axios";
import searchListValues from "@/components/searchListValues.vue"
import { densityList } from '@/utils/density.js';
import list from "./list.vue";
export default {
  data() {
    return {
      pageBg: false,
      listInfo: {},
      searchAddList: false, //是否显示search list window
      titleName: "",
      pageInfo: {},
      columnInfo: [],
      column: [],
      titlePage: "",
      ColPage: "false",
      isClearable: true,
      searchMf: "",
      dateList: [],
      list: [],
      casMultiData: [],
      pageOrder: [this.$t("message.title.pageOne"), this.$t("message.title.pageTwo"), this.$t("message.title.pageThree")],

      pageData: [],
      multiList: [],
      cascadeList: [],
      cascadeMultiList: [],
      multi: { multiple: true, checkStrictly: true },
      // typeList: [1000002, 1004003, 1011002, 1012005],
      // nameList: [1000001, 1004001, 1011001, 1012001],
      input_width: {
        width: "100%",
      },
      getLifeVal: false,
      // input_width2: {
      //   width: "50%",
      // },

      currencyIdList: [],

      resetNum: "",
      nameId: "",
      baseId: "",
      basicData: {},
      subData: {},
      isReq: true,

    };
  },
  components: {
    Spe, searchListValues, list
  },
  props: ["page", "pageIndex", "reset", "editNum", "itemSubClassId",],
  methods: {
    // addToListDisplay(selectedListValue){

    //   if(this.listInfo.uiType==3){
    //     this.searchAddList = false;
    //     this.pageData[selectedListValue.listIndex] = selectedListValue.listId;
    //     this.upSimpleList(selectedListValue.listIndex)
    //   }else if (this.listInfo.uiType==4){
    //     this.pageData[selectedListValue.listIndex].push(selectedListValue.listId);
    //     this.upMultiList(selectedListValue.listIndex)
    //   }
    // },
    updateListEntries(e) {

      this.columnInfo.map(i => {
        if (i.listId == this.listInfo.listId) {
          i.listEntrie = e.map(i => ({ id: i.listId + "_" + i.entryId, name: i.entryValue }));
        }
      })
    },
    openSearchListWindow(item) {
      this.searchAddList = true;
      this.listInfo = item;

    },

    getColumn() {

      if (!this.page.val) {
        return
      }
      this.getLifeVal = false;

      // console.log(this.page);


      let valArr = this.deepCopy(this.page.val);

      this.baseId = parseInt(this.$route.query.classId.toString().substr(0, 3));
      let column = this.getNewData(this.page.column);

      const arr = valArr.cells.map(i => {
        if (typeof i.val === 'object') {
          i.val = ''
        }
        return i
      })
      const simpleUiType = [1, 2, 6, 7, 8, 10];

      column.map((i, e) => {

        i.val = arr[e]

        if (simpleUiType.includes(i.uiType)) {
          this.pageData[i.index] = arr[e].val;
        }
        if (i.id == 1012002) {
          this.searchMf = arr[e].val;
        };
        if (i.id == 1000001) {
          // this.searchMf = arr[e].val;
          this.pageData[i.index] = '编号自动生成'
        };

        if (i.uiType == 3) {

          if (i.editable == false) {
            i.listEntrie = [{ id: arr[e].id, name: arr[e].val }]
          }
          this.pageData[i.index] = arr[e].id == 0 ? '' : arr[e].id

        }
        if (i.uiType == 4) {
          this.pageData[i.index] = !arr[e].ids ? [] : arr[e].ids.split(';')
        }

        if (i.uiType == 10) {
          let n = parseFloat(arr[e].realVal);
          this.pageData[i.index] = !n ? '' : n.toFixed(2);
          this.currencyIdList[i.index] = JSON.stringify(arr[e].currencyCode) == "{}" ? '' : arr[e].currencyCode + ''
          i.val = arr[e];
        }
      });
      this.columnInfo = column;
      column.map(i => {
        return this.basicData[i.id] = this.pageData[i.index];
      })

      let list = this.columnInfo.filter(i => i.required).map(i => i.id)

      this.isReq = true;
      for (const key in list) {
        let e = list[key]
        if (!this.basicData[e] || JSON.stringify(this.basicData[e]) == '[]') {
          this.isReq = false;
        }
      }
      this.subData = {}
      this.$emit('update:checkReq', this.isReq);
      this.getLifecycle();
    },

    getLifecycle() {
      if (this.pageIndex != 0) {
        return;
      }

      const arr = [
        { url: '/pmdm/admin/lifecycle/getLifecyclePhaseBySubclass', id: 101, query: { subclassId: this.$store.state.objectId.subClassId }, columnId: 1000006 },
        { url: '/pmdm/admin/workflow/getWorkflowBySubclass', id: 104, query: { subclassId: this.$store.state.objectId.subClassId }, columnId: 1004008 },
        { url: '/pmdm/admin/workflow/getWorkflowBySubclass', id: 401, query: { subclassId: this.$store.state.objectId.subClassId }, columnId: 4010004 },
        { url: '/pmdm/admin/lifecycle/getLifecyclePhaseByClass', id: 105, query: { clsId: 10501 }, columnId: 1011003 },
        { url: '/pmdm/admin/lifecycle/getLifecyclePhaseByClass', id: 106, query: { clsId: 10501 }, columnId: 1012003 },
        { url: '/pmdm/admin/role/getAll', id: 901, query: {}, columnId: 1090016 },
        { url: '/pmdm/admin/role/getAll', id: 902, query: {}, columnId: 1092005 },
        { url: '/pmdm/admin/lifecycle/getLifecyclePhaseBySubclass', id: 501, query: { subclassId: this.$store.state.objectId.subClassId }, columnId: 5010006 },
        { url: '', id: 502, query: { subclassId: this.$store.state.objectId.subClassId } },
      ]
      const item = arr.find(i => i.id == this.baseId);
      if (item.url) {
        axios.get(`${item.url + this.params(item.query)}`).then(res => {
          const origin = res.data.object;

          let list = [];
          if (!Array.isArray(origin)) {
            if (origin.hasOwnProperty('phases')) {
              list = origin.phases.map(i => ({ name: i.phaseName, id: i.id }))
            } else if (origin.hasOwnProperty('roles')) {
              list = origin.roles.map(i => ({ id: i.id, name: i.name }))
            }
          }
          else {
            list = origin.map(i => ({ name: i.name, id: i.id + '' }));
          }
          if (list.length > 0) {
            this.columnInfo.find(i => i.id == item.columnId).listEntrie = list;
          }
          this.columnInfo.find(i => i.id == item.columnId).listEntrie = list;
          this.getLifeVal = true
        })
      } else {
        this.getLifeVal = true
      }

    },

    upInput(i) {
      this.$forceUpdate();
      this.$emit("hasChanged");
      if (this.columnInfo.find(item => item.index == i).uiType == 10) {
        let n = this.pageData[i];
        this.pageData[i] = n.replace(/[^0-9.]/g, '');
        if (!Number(n)) {
          this.pageData[i] = '';
        }
      }
    },
    emitInput(i) {
      let n = this.pageData[i];
      let m = this.columnInfo.find(item => item.index == i).id;
      this.$set(this.subData, m, n.trim());
      this.upData()
    },
    upDateTime(i) {
      let m = this.columnInfo.find(item => item.index == i).id;
      this.$set(this.subData, m, this.pageData[i]);
      this.upData();
    },
    upCascadeList(i) {
      this.$forceUpdate()
      let n = this.pageData[i];
      if (n == undefined) {
        return
      }
      let m = this.columnInfo.find(item => item.index == i).id;
      this.subData[m] = !!n && JSON.stringify(n) != '[]' ? n[n.length - 1] : ''
      this.upData()
    },



    upList(e) {
      const { val, item } = e;
      let m = this.columnInfo.find(i => i.index == item.index).id;
      this.$set(this.subData, m, val);
      this.upData()

      // const { id, clsId } = this.pageId;
      const id = item.id,
        clsId = this.$store.state.objectId.classId;
      const idGetAttr = clsId === 10101 || ![1010101, 9020102].includes(id)

      idGetAttr && this.getAttri({ item, val }).then(res => {
        const obj = res.data.object;

        Object.keys(obj).forEach((id) => {
          const index = this.columnInfo.findIndex(i => i.id == id);
          this.$set(this.pageData, index, obj[id])
        })

        this.subData = { ...this.subData, ...obj }
        this.upData()
      }).finally(res => {
        this.$forceUpdate();
      })
    },

    getAttri(e) {
      const { val, item } = e
      const str = item.id == 1001051 ? 1 : item.id == 1001052 ? 2 : '';

      if (!str) {
        return new Promise(() => { },)
      } else {
        return axios.get(`pmdm/items/buildValueByArrIdsByList0${str}DaoSen?list0${str}Value=${val}`);
      }
    },

    upCurrency(i) {
      let n = parseFloat(this.pageData[i]).toFixed(2);
      n = isNaN(n) ? '' : n
      const m = this.columnInfo.find(item => item.index == i).id;
      this.$set(this.pageData, i, n)
      this.subData[m] = n;
      if (!this.currencyIdList[i]) {
        const currencyId = this.columnInfo.find(item => item.index == i).val.currencyId;
        const defaultCurrency = this.columnInfo.find(item => item.index == i).listEntrie[0].id;
        this.currencyIdList[i] = defaultCurrency;
        this.subData[currencyId] = defaultCurrency;
      }
      this.upData()
    },
    upCurrencyId(i) {
      const currencyId = this.columnInfo.find(item => item.index == i).val.currencyId;
      this.subData[currencyId] = this.currencyIdList[i];
      this.$forceUpdate();
      this.upData();
    },
    arrLast(n) {
      return n.length > 0 ? n[n.length - 1] : ''
    },
    // arrSort(n){
    //   n = n.length > 0 ? n.sort((a,b)=>a-b).join(';') : ''
    //   return n;
    // },

    upData() {
      this.$emit("update:change", this.subData);
      this.$emit("hasChanged");
      let arr = this.columnInfo.filter(i => i.required).map(i => i.id)
      let m = Object.assign(this.basicData, this.subData)
      // this.isReq = arr.some(i => )
      this.isReq = true
      for (const key in arr) {
        let e = arr[key]
        if (!Boolean(m[e])) {
          this.isReq = false;
          break
        }
        // else{
        //   this.isReq = true;
        // }
      }
      this.$emit('update:checkReq', this.isReq)
    },

    getMFInfo(e) {
      if (e) {
        this.subData["1012002"] = e.label
        this.upData()
        this.$emit("MFValue", e.value);
      }
    },

  },
  mounted() {
    this.titlePage = this.pageOrder[this.pageIndex];
    this.ColPage = !!this.pageIndex;
    this.pageBg = !!(this.pageIndex == 1);

  },
  created() {
    this.getColumn();

  },
  watch: {
    editNum(e) {
      if (e % 2) {
        this.getColumn()
        // this.getLifecycle()
      } else {
        this.pageData = [];
        this.subData = {};
        this.$emit("update:change", this.subData);
      }
    },


  },
};
</script>

<style>
ol,
ul {
  list-style: none;
}

.moneyUi .el-input-group__append {
  width: 30% !important;
}

.v-modal {
  opacity: 0.5 !important;
  background: rgba(0, 0, 0, 0.5) !important;
  display: none;
}
</style>

<style scoped>
.searchAddList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.searchAddList .el-carousel__container {
  height: 450px !important;
}

.divFix {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}

.pg2 {
  overflow: hidden;
  background: #f3f7fa;
  background-image: url(~@/assets/titleBlock/page2.png);
  background-repeat: no-repeat;
  background-position: bottom right;
}

.active {
  width: 33%;
  float: left;
}

.active2 {
  text-align: left;
  width: 33%;
  display: block;
}

.isHeading {
  width: 100%;
}

.heading {
  width: 100%;
  float: left;
  margin: -10px 0 18px 25px;
}

.heading-edit {
  width: 100% !important;
  margin: 0 0 8px 40px;
}

.heading p {
  font-size: 16px;
  margin: 0;
}

.title-heading {
  width: 100%;
  float: left;
  margin: 0 0 18px -20px;
}

.title-heading p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.heading-edit {
  width: 100% !important;
  margin: 0 0 18px 40px;
}
</style>
